import React from "react";
import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PaymentIcon from "@mui/icons-material/Payment";
import VerifiedIcon from "@mui/icons-material/Verified";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import fetchIpData from "../cookies/fetchIpData";

const features = [
  {
    icon: <LocalShippingIcon sx={{ color: "#d32f2f", fontSize: "60px" }} />,
    title: "Nopea ja ilmainen toimitus",
    description: "Nopea ja ilmainen toimitus pääkaupunkiseudun alueella.",
  },
  {
    icon: <PaymentIcon sx={{ color: "#d32f2f", fontSize: "60px" }} />,
    title: "Helppo maksaminen",
    description:
      "Klarna, MobilePay, pankkisiirto, korttimaksu toimituksen yhteydessä.",
  },
  {
    icon: <VerifiedIcon sx={{ color: "#d32f2f", fontSize: "60px" }} />,
    title: "Laadukas ja luotettava palvelu",
    description: "Tarjoamme korkealaatuista ja luotettavaa palvelua.",
  },
  {
    icon: <SupportAgentIcon sx={{ color: "#d32f2f", fontSize: "60px" }} />,
    title: "Asiakastuki",
    description: "Ota yhteyttä, olemme täällä sinua varten ympäri vuorokauden.",
  },
];

function ResponsiveFeatures({array}) {
  console.log(array)
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md")); // Mobil kontrol
  const features_ = array > -1 ? [features[array]]:features
  return (
    <Box
      sx={{
        mt:'5vh',
        mb:'5vh',
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Stack
        direction={isMobile ? "row" : "row"} // Mobilde dikey, geniş ekranda yatay
        spacing={4}
        sx={{ width: "100%" }}
        justifyContent="center"
        alignItems= {isMobile ? 'center':"center"}
      >
        {features_.map((feature, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: isMobile ? "column" : "column", // Mobilde yan yana, geniş ekranda alt alta
              textAlign: isMobile ? "center" : "center", // Mobilde sola hizalı
              maxWidth: isMobile ? "100%" : "100%", // Mobilde tam genişlik, geniş ekranda %20
            }}
          >
            {/* İkon */}
            {feature.icon}

            {/* Başlık */}
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                fontSize: isMobile ? "14px" : "18px", // Mobilde daha küçük font
                marginLeft: isMobile ? 1 : 0, // Mobilde ikondan sonra biraz boşluk
              }}
            >
              {feature.title}
            </Typography>

            {/* Açıklama */}
            <Typography
              className="description"
              variant="body2"
              color="textSecondary"
              sx={{
                display: isMobile ? "block" : "block", // Mobilde varsayılan olarak gizle
                marginTop: isMobile ? 0 : 1, // Geniş ekranda yukarı boşluk
                marginLeft: isMobile ? 2 : 0, // Mobilde açıklamayı başlıktan biraz uzaklaştır
              }}
            >
              {feature.description}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}

export default ResponsiveFeatures;
